import { CustomCellRendererProps } from 'ag-grid-react'
import React from 'react'
import { useTradingEntity } from 'view/hooks'

export const TradingEntityPublishedNameRenderer = ({ value }: { value: CustomCellRendererProps['value'] }) => {
  const tradingEntity = useTradingEntity(value)

  return <span>{tradingEntity?.publishedName}</span>
}
